import styled, { css } from "styled-components";

export interface BlockPalette {
    white: string;
    lightGrey: string;
    greenWhite: string;
    lightGreen: string;
    green: string;
    darkGreen: string;
    gold: string;
    primaryBtnBg: string;
    primaryBtnBgHover: string;
}

export const blockPalette: BlockPalette = {
    white: `#FFFFFF`,
    lightGrey: `#E5E5E5`,
    greenWhite: `#E5EDE9`,
    lightGreen: `#5e9351`,
    green: `#205C40`,
    darkGreen: `#114734`,
    gold: `#998D6B`,
    primaryBtnBg: `#C2DE54`,
    primaryBtnBgHover: `#B5D04D`,
};

export interface BlockTheme {
    container: any;
    rowMargin: any;
    pTypography: any;
    hTypography: any;
}

export const blockTheme: BlockTheme = {
    container: css`
        width: 100%;
        max-width: 90vw;
        /* Small Devices, Tablets */
        @media screen and (min-width: 768px) {
            width: 92vw;
            max-width: 1920px;
        }
    `,
    rowMargin: css`
        margin: 16px auto 64px;
    `,
    pTypography: css`
        color: ${blockPalette.green};
        font-size: 1rem;
        line-height: 1.5;
        font-weight: 400;
        font-family: Lato;
    `,
    hTypography: css`
        display: block;
        color: ${blockPalette.green};
        font-family: LibreBaskervilleBold;
        font-weight: 700;
    `,
};

export const ContentBlockStyles = styled.div`
    overflow: auto;

    /* =============== Base Styles =============== */
    * {
        box-sizing: border-box;
    }

    .sr-only:not(:focus):not(:active) {
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }

    a {
        color: ${blockPalette.green};
        // Hover/Focus
        &:focus,
        &:hover {
            color: ${blockPalette.green};
            text-decoration: underline;
        }
        // Sub Elements
        & > span[class^="TypographyStyle"] {
            // Targeting the spans created inside Link Elements
            color: ${blockPalette.green};
        }
        &:focus > span[class^="TypographyStyle"],
        &:hover > span[class^="TypographyStyle"] {
            color: ${blockPalette.green};
        }
    }

    h1, .h1,
    h2, .h2,
    h3, .h3,
    h4, .h4,
    h5, .h5,
    h6, .h6 {
        ${blockTheme.hTypography}
    }

    p {
        ${blockTheme.pTypography}
    }

    img {
        max-width: 100%;
    }

    /* =============== Buttons =============== */
    .button,
    .btn {
        display: inline-block;
        margin-top: 1.5rem;
        width: 100%;
        padding: 0.75rem 1.5rem;
        background-color: ${blockPalette.primaryBtnBg};
        border-radius: 4px;
        color: ${blockPalette.green};
        font-size: 1rem;
        font-family: "LatoMedium";
        line-height: 1;
        text-align: center;
        transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;
        // Media Queries
        /* Small Devices, Tablets */
        @media screen and (min-width: 768px) {
            width: auto;
        }
        // Hover & Focus
        &:focus,
        &:hover {
            background-color: ${blockPalette.primaryBtnBgHover};
            transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;
            text-decoration: none;
        }
        // Sub Elements
        & > span[class^="TypographyStyle"] {
            display: block;
            color: ${blockPalette.green};
        }
        &:focus > span[class^="TypographyStyle"],
        &:hover > span[class^="TypographyStyle"] {
            color: ${blockPalette.green};
        }
    }

    .btn--primary {
        background-color: ${blockPalette.primaryBtnBg};
        // Hover & Focus
        &:focus,
        &:hover {
            background-color: ${blockPalette.primaryBtnBgHover};
        }
    }
    .btn--ghost-primary {
        background-color: transparent;
        border: 1px solid ${blockPalette.white};
        color: ${blockPalette.white};
        // Hover & Focus
        &:focus,
        &:hover {
            background-color: ${blockPalette.white};
            border-color: transparent;
            color: ${blockPalette.darkGreen};
        }
        // Sub Elements
        & > span[class^="TypographyStyle"] {
            display: block;
            color: ${blockPalette.white};
        }
        &:focus > span[class^="TypographyStyle"],
        &:hover > span[class^="TypographyStyle"] {
            color: ${blockPalette.darkGreen};
        }
    }
    .btn--ghost-secondary {
        background-color: transparent;
        border: 1px solid ${blockPalette.darkGreen};
        color: ${blockPalette.darkGreen};
        // Hover & Focus
        &:focus,
        &:hover {
            background-color: ${blockPalette.darkGreen};
            border-color: transparent;
            color: ${blockPalette.white};
        }
        // Sub Elements
        & > span[class^="TypographyStyle"] {
            display: block;
            color: ${blockPalette.darkGreen};
        }
        &:focus > span[class^="TypographyStyle"],
        &:hover > span[class^="TypographyStyle"] {
            color: ${blockPalette.white};
        }
    }
`;